
import { useState } from 'react';
import { lazy, Suspense } from "react";
import { useAuth } from '@/contexts/AuthContext';
import { usePageTitle } from '@/hooks/usePageTitle';
import { TableSkeleton } from '@/components/ui/skeletons';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import { PageHeader } from '@/components/ui/page-header';

const MembersTable = lazy(
  () => import('@/components/team/members-table').then(m => ({ default: m.MembersTable }))
);
const InviteDialog = lazy(
  () => import('@/components/team/invite-dialog').then(m => ({ default: m.InviteDialog }))
);

function TeamPage() {
  usePageTitle('Team');
  const { currentOrg } = useAuth();
  const [inviteOpen, setInviteOpen] = useState(false);
  const isAdmin = currentOrg?.role === 'Admin' || currentOrg?.role === 'Owner';

  return (
    <div className="space-y-6">
      <PageHeader
        title="Team"
        description={`Manage members and invitations for ${currentOrg?.name ?? ""}`}
        askAi
        hideTitleOnMobile={false}
        actions={
          isAdmin ? (
            <Button onClick={() => setInviteOpen(true)}>
              <UserPlus className="mr-2 h-4 w-4" />
              Invite Member
            </Button>
          ) : null
        }
      />
      <MembersTable />
      <InviteDialog open={inviteOpen} onOpenChange={setInviteOpen} />
    </div>
  );
}

import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/settings/team')({
  component: TeamPage,
  pendingComponent: () => <div className="flex flex-col gap-4 flex-1 min-h-0"><TableSkeleton rows={8} /></div>,
  pendingMs: 0,
  pendingMinMs: 150,
});
